"use client"
/* */
import { jsx, jsxs } from 'react/jsx-runtime';
import styles from './Avatar.module.scss.mjs';
import clsx from 'clsx';
import { ClearPropsContext } from '../ClearPropsContext/ClearPropsContext.mjs';
import '../../lib/propsContext/propsContext.mjs';
import { PropsContextProvider } from '../../lib/propsContext/PropsContextProvider.mjs';
import { flowComponent } from '../../lib/componentFactory/flowComponent.mjs';
import { AlertIcon } from '../AlertIcon/AlertIcon.mjs';

const Avatar = flowComponent("Avatar", (props) => {
  const { children, className, color, size = "m", status, ref } = props;
  const rootClassName = clsx(
    styles.avatar,
    styles[`size-${size}`],
    className,
    !status && styles[color ?? "blue"],
    status && styles[status]
  );
  const useDynamicColor = color === void 0 && status === void 0;
  const propsContext = {
    Initials: {
      className: styles.initials,
      useDynamicColor
    },
    Icon: {
      className: styles.icon
    }
  };
  return /* @__PURE__ */ jsx(ClearPropsContext, { children: /* @__PURE__ */ jsx("div", { className: rootClassName, ref, children: /* @__PURE__ */ jsxs(PropsContextProvider, { props: propsContext, children: [
    !status && children,
    status && /* @__PURE__ */ jsx(AlertIcon, { className: styles.icon, status })
  ] }) }) });
});

export { Avatar, Avatar as default };
//# sourceMappingURL=Avatar.mjs.map
